import axios from "axios";

const sendEmailToOwner = ({
  userEmail, // Default email
  itemName, // Default item
  subject, // Default subject
  message, // Default message
  recepient, // Optional recipient
}) => {
  // Create the payload and include recipient only if it's provided

  const payload = {
    userEmail,
    itemName,
    subject,
    message,
    recepient: process.env.REACT_APP_OWNER_EMAIL,
  };

  console.log("Owner email payload:", payload);
  // If recipient is provided, add it to the payload

  // Make the POST request
  return axios.post(
    `${process.env.REACT_APP_SERVER_URL}/purchases/send-email`,
    payload,
    {
      headers: {
        "Content-Type": "application/json", // Ensure the correct content type
      },
    }
  );
};

export default sendEmailToOwner;
